export const POPUP_INFORMATION_CLOSE_REASON = {
  close: 'close',
  submit: 'submit',
  additionalAction: 'additionalAction',
};
